// extracted by mini-css-extract-plugin
export default {"pageInfo":"PageInfoV4_pageInfo__IYtKn","header":"PageInfoV4_header__4QpcQ","line":"PageInfoV4_line__8ai6M","textBox":"PageInfoV4_textBox__4sHnf","image":"PageInfoV4_image__baPYg"};